// import React, { lazy, Suspense, useEffect } from "react";
// import { Route, Routes } from "react-router-dom";
// import { Helmet } from "react-helmet";
// import { ToastContainer } from "react-toastify";
// import "./App.css";
// import "react-toastify/dist/ReactToastify.css";
// import Navbar from "./Components/Navbar/Navbar";
// import Footer from "./Components/Footer/Footer";
// import SafePage from "./Errors Handlers/SafePage";
// import PageErrorBoundary from "./Errors Handlers/ErrorHandler";
// import LoadingAnimation from "./Components/Loading Animations/LoadingAnimations";

// const Home = lazy(() => import("./Pages/Home/Home"));
// const About = lazy(() => import("./Pages/About/About"));
// const Services = lazy(() => import("./Pages/Services/Services"));
// const Portfolio = lazy(() => import("./Pages/Portfolio/Portfolio"));
// const ProjectDetails = lazy(
//   () => import("./Pages/Project Detail/ProjectDetail"),
// );
// const Pricing = lazy(() => import("./Pages/Pricing/Pricing"));
// const Contact = lazy(() => import("./Pages/Contact/Contact"));
// const Careers = lazy(() => import("./Pages/Careers/Careers"));
// const Blogs = lazy(() => import("./Pages/Blogs/Blogs"));
// const BlogDetails = lazy(() => import("./Pages/Blogs/BlogDetail"));
// const Support = lazy(() => import("./Pages/Support/Support"));
// const PrivacyPolicy = lazy(() => import("./Pages/Privacy/Privacy"));
// const TermsConditions = lazy(
//   () => import("./Pages/TermsAndConditions/TermsAndConditions"),
// );
// const BlogReadingManage = lazy(
//   () => import("./Components/Blog Reader Management/BlogReadingManage"),
// );
// const NotFound = lazy(() => import("./Components/NotFound/NotFound"));
// const FloatingActions = lazy(
//   () => import("./Components/Floating Buttons/TopandWhatsapp"),
// );

// function App() {
//   useEffect(() => {
//     const handleGlobalError = (event) => {
//       console.error("[Global JavaScript Error]", {
//         message: event?.message,
//         error: event?.error,
//         source: event?.filename,
//         line: event?.lineno,
//         column: event?.colno,
//         url: window.location.href,
//       });
//     };

//     const handleUnhandledPromise = (event) => {
//       console.error("[Unhandled Promise Rejection]", {
//         reason: event?.reason,
//         url: window.location.href,
//       });

//       event.preventDefault();
//     };

//     window.addEventListener("error", handleGlobalError);
//     window.addEventListener("unhandledrejection", handleUnhandledPromise);

//     return () => {
//       window.removeEventListener("error", handleGlobalError);

//       window.removeEventListener("unhandledrejection", handleUnhandledPromise);
//     };
//   }, []);

//   return (
//     <>
//       <Helmet>
//         <title>
//           NexGen Web Designs | Professional Website Development Company
//         </title>

//         <meta
//           name="description"
//           content="NexGen Web Designs builds fast, responsive and SEO-friendly websites for startups, small businesses and enterprises."
//         />
//       </Helmet>

//       <Suspense fallback={<LoadingAnimation />}>
//         <div className="App">
//           <PageErrorBoundary pageName="Navbar" silent>
//             <Navbar />
//           </PageErrorBoundary>

//           <Routes>
//             <Route
//               path="/"
//               element={
//                 <SafePage pageName="Home">
//                   <Home />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/about"
//               element={
//                 <SafePage pageName="About">
//                   <About />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/services"
//               element={
//                 <SafePage pageName="Services">
//                   <Services />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/portfolio"
//               element={
//                 <SafePage pageName="Portfolio">
//                   <Portfolio />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/portfolio/:slug"
//               element={
//                 <SafePage pageName="Project Details">
//                   <ProjectDetails />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/pricing"
//               element={
//                 <SafePage pageName="Pricing">
//                   <Pricing />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/contact"
//               element={
//                 <SafePage pageName="Contact">
//                   <Contact />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/careers"
//               element={
//                 <SafePage pageName="Careers">
//                   <Careers />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/blogs"
//               element={
//                 <SafePage pageName="Blogs">
//                   <Blogs />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/blogs/:slug"
//               element={
//                 <SafePage pageName="Blog Details">
//                   <BlogDetails />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/support"
//               element={
//                 <SafePage pageName="Support">
//                   <Support />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/privacy-policy"
//               element={
//                 <SafePage pageName="Privacy Policy">
//                   <PrivacyPolicy />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/terms-and-conditions"
//               element={
//                 <SafePage pageName="Terms and Conditions">
//                   <TermsConditions />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="/dashboard/blog-reading"
//               element={
//                 <SafePage pageName="Blog Reading Dashboard">
//                   <BlogReadingManage />
//                 </SafePage>
//               }
//             />

//             <Route
//               path="*"
//               element={
//                 <SafePage pageName="Not Found">
//                   <NotFound />
//                 </SafePage>
//               }
//             />
//           </Routes>

//           <PageErrorBoundary pageName="Floating Actions" silent>
//             <FloatingActions />
//           </PageErrorBoundary>

//           <PageErrorBoundary pageName="Footer" silent>
//             <Footer />
//           </PageErrorBoundary>
//         </div>
//       </Suspense>

//       <ToastContainer
//         position="top-right"
//         autoClose={3500}
//         newestOnTop
//         closeOnClick
//         pauseOnFocusLoss
//         draggable
//         pauseOnHover
//         theme="colored"
//         limit={2}
//       />
//     </>
//   );
// }
// export default App;

import React, { Suspense, useEffect } from "react";

import { Route, Routes } from "react-router-dom";

import { Helmet } from "react-helmet";
import { ToastContainer } from "react-toastify";

import "./App.css";
import "react-toastify/dist/ReactToastify.css";

import Navbar from "./Components/Navbar/Navbar";
import Footer from "./Components/Footer/Footer";

import SafePage from "./Errors Handlers/SafePage";
import PageErrorBoundary from "./Errors Handlers/ErrorHandler";

import LoadingAnimation from "./Components/Loading Animations/LoadingAnimations";

import lazyWithRetry from "./Errors Handlers/SafeLazy";

const Home = lazyWithRetry(() => import("./Pages/Home/Home"), "Home");

const About = lazyWithRetry(() => import("./Pages/About/About"), "About");

const Services = lazyWithRetry(
  () => import("./Pages/Services/Services"),
  "Services",
);

const Portfolio = lazyWithRetry(
  () => import("./Pages/Portfolio/Portfolio"),
  "Portfolio",
);

const ProjectDetails = lazyWithRetry(
  () => import("./Pages/Project Detail/ProjectDetail"),
  "ProjectDetails",
);

const Pricing = lazyWithRetry(
  () => import("./Pages/Pricing/Pricing"),
  "Pricing",
);

const Contact = lazyWithRetry(
  () => import("./Pages/Contact/Contact"),
  "Contact",
);

const Careers = lazyWithRetry(
  () => import("./Pages/Careers/Careers"),
  "Careers",
);

const Blogs = lazyWithRetry(() => import("./Pages/Blogs/Blogs"), "Blogs");

const BlogDetails = lazyWithRetry(
  () => import("./Pages/Blogs/BlogDetail"),
  "BlogDetails",
);

const Support = lazyWithRetry(
  () => import("./Pages/Support/Support"),
  "Support",
);

const PrivacyPolicy = lazyWithRetry(
  () => import("./Pages/Privacy/Privacy"),
  "PrivacyPolicy",
);

const TermsConditions = lazyWithRetry(
  () => import("./Pages/TermsAndConditions/TermsAndConditions"),
  "TermsConditions",
);

const BlogReadingManage = lazyWithRetry(
  () => import("./Components/Blog Reader Management/BlogReadingManage"),
  "BlogReadingManage",
);

const NotFound = lazyWithRetry(
  () => import("./Components/NotFound/NotFound"),
  "NotFound",
);

const FloatingActions = lazyWithRetry(
  () => import("./Components/Floating Buttons/TopandWhatsapp"),
  "FloatingActions",
);

function App() {
  useEffect(() => {
    const handleGlobalError = (event) => {
      console.error("[Global JavaScript Error]", {
        message: event?.message,
        error: event?.error,
        source: event?.filename,
        line: event?.lineno,
        column: event?.colno,
        url: window.location.href,
        capturedAt: new Date().toISOString(),
      });
    };

    const handleUnhandledPromise = (event) => {
      console.error("[Unhandled Promise Rejection]", {
        reason: event?.reason,
        url: window.location.href,
        capturedAt: new Date().toISOString(),
      });

      /*
       * This only prevents duplicate browser logging.
       * It does not repair the failed promise.
       */
      event.preventDefault();
    };

    window.addEventListener("error", handleGlobalError);

    window.addEventListener("unhandledrejection", handleUnhandledPromise);

    return () => {
      window.removeEventListener("error", handleGlobalError);

      window.removeEventListener("unhandledrejection", handleUnhandledPromise);
    };
  }, []);

  return (
    <>
      <Helmet>
        <title>
          NexGen Web Designs | Professional Website Development Company
        </title>

        <meta
          name="description"
          content="NexGen Web Designs builds fast, responsive and SEO-friendly websites for startups, small businesses and enterprises."
        />
      </Helmet>

      <Suspense fallback={<LoadingAnimation />}>
        <div className="App">
          <PageErrorBoundary pageName="Navbar" silent>
            <Navbar />
          </PageErrorBoundary>

          <Routes>
            <Route
              path="/"
              element={
                <SafePage pageName="Home">
                  <Home />
                </SafePage>
              }
            />

            <Route
              path="/about"
              element={
                <SafePage pageName="About">
                  <About />
                </SafePage>
              }
            />

            <Route
              path="/services"
              element={
                <SafePage pageName="Services">
                  <Services />
                </SafePage>
              }
            />

            <Route
              path="/portfolio"
              element={
                <SafePage pageName="Portfolio">
                  <Portfolio />
                </SafePage>
              }
            />

            <Route
              path="/portfolio/:slug"
              element={
                <SafePage pageName="Project Details">
                  <ProjectDetails />
                </SafePage>
              }
            />

            <Route
              path="/pricing"
              element={
                <SafePage pageName="Pricing">
                  <Pricing />
                </SafePage>
              }
            />

            <Route
              path="/contact"
              element={
                <SafePage pageName="Contact">
                  <Contact />
                </SafePage>
              }
            />

            <Route
              path="/careers"
              element={
                <SafePage pageName="Careers">
                  <Careers />
                </SafePage>
              }
            />

            <Route
              path="/blogs"
              element={
                <SafePage pageName="Blogs">
                  <Blogs />
                </SafePage>
              }
            />

            <Route
              path="/blogs/:slug"
              element={
                <SafePage pageName="Blog Details">
                  <BlogDetails />
                </SafePage>
              }
            />

            <Route
              path="/support"
              element={
                <SafePage pageName="Support">
                  <Support />
                </SafePage>
              }
            />

            <Route
              path="/privacy-policy"
              element={
                <SafePage pageName="Privacy Policy">
                  <PrivacyPolicy />
                </SafePage>
              }
            />

            <Route
              path="/terms-and-conditions"
              element={
                <SafePage pageName="Terms and Conditions">
                  <TermsConditions />
                </SafePage>
              }
            />

            <Route
              path="/dashboard/blog-reading"
              element={
                <SafePage pageName="Blog Reading Dashboard">
                  <BlogReadingManage />
                </SafePage>
              }
            />

            <Route
              path="*"
              element={
                <SafePage pageName="Not Found">
                  <NotFound />
                </SafePage>
              }
            />
          </Routes>

          <PageErrorBoundary pageName="Floating Actions" silent>
            <FloatingActions />
          </PageErrorBoundary>

          <PageErrorBoundary pageName="Footer" silent>
            <Footer />
          </PageErrorBoundary>
        </div>
      </Suspense>

      <ToastContainer
        position="top-right"
        autoClose={3500}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        limit={2}
      />
    </>
  );
}

export default App;
